import { all } from 'redux-saga/effects';
import { watchList } from './list';
import watchCache from './cache';

export function* watchMedications() {
  yield all([watchList(), watchCache()]);
}
